import React from 'react';

function concatClassName(type, acceptedExchange) {
  return `shift ${type} ${acceptedExchange ? ' exchanged' : ''}`;
}

const ScheduleShiftLabel = ({ type, label, acceptedExchange }) => <div className={concatClassName(type, acceptedExchange)}>{label}</div>;

export default ScheduleShiftLabel;
